/*
 * Form Options
 */
import { Component, registerComponent } from 'js/component.js';
import { sendFormStartEvent } from 'js/dataLayer.js';
import 'vendor/selectr/selectr.less';
import Selectr from 'mobius1-selectr';
const componentName = 'form-options';

export class FormOptions extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        parentForm: this.element.closest('form'),
        radioInputs: this.element.querySelectorAll('input[type="radio"]'),
        checkboxInputs: this.element.querySelectorAll('input[type="checkbox"]'),
        selectBox: this.element.querySelector('select'),
    };

    // Util & State
    isRadio = this.elements.radioInputs.length > 0;
    isCheckbox = this.elements.checkboxInputs.length > 0;
    isSelect = this.elements.selectBox !== null;
    isMultiSelect = this.elements.selectBox ? this.elements.selectBox.getAttribute('multiple') !== null : false;
    isRequired = this.element.getAttribute('data-required') !== null;

    selectInstance = null;
    selectedLabel = this.element.getAttribute('data-selected-label') || '';
    placeholderLabel = this.element.getAttribute('data-placeholder-label') || null;

    digitalData = window.digitalData = window.digitalData || [];
    formName = this.elements.parentForm.getAttribute('data-name') || 'default';
    formId = this.elements.parentForm.getAttribute('data-id') || 'default';
    formTitle = this.elements.parentForm.getAttribute('data-title') || 'default';
    formType = this.elements.parentForm.getAttribute('data-type') || 'default';

    /**
     * On Input Change
     */
    onInputChange = () => {
        // Send Data Layer Event
        sendFormStartEvent(this.formName, this.formId, this.formTitle, this.formType);

        // Validate
        if(this.isRequired) {
            const optionsParent = this.element.parentNode;

            // Radios + Checkboxes
            if(this.isRadio || this.isCheckbox) {
                const inputEles = this.element.querySelectorAll('input');
                let isEmpty = true;

                [...inputEles].map((inputEle) => {//eslint-disable-line
                    if(inputEle.checked === true) isEmpty = false;
                });

                if(!isEmpty) {
                    optionsParent.classList.remove('error');
                } else {
                    optionsParent.classList.add('error');
                }
            }

            // Selects
            if(this.isSelect) {
                const isEmpty = this.element.querySelectorAll('option[selected]:not([value="placeholder"]').length === 0;
                if(!isEmpty) {
                    optionsParent.classList.remove('error');
                } else {
                    optionsParent.classList.add('error');
                }
            }
        }
        return false;
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        if(this.isRadio) [...this.elements.radioInputs].map((ele) => ele.addEventListener('click', this.onInputChange));
        if(this.isCheckbox) [...this.elements.checkboxInputs].map((ele) => ele.addEventListener('click', this.onInputChange));
        if(this.isSelect) this.elements.selectBox.addEventListener('change', this.onInputChange);
    };

    /**
     * Use Custom Selects
     */
    useCustomSelects = () => {
        if(this.elements.selectBox) {
            const selectrOptions = {};
            if(this.placeholderLabel) selectrOptions.placeholder = this.placeholderLabel;

            this.selectInstance = new Selectr(this.elements.selectBox, selectrOptions);

            this.selectInstance.on('selectr.init', () => {
                const labelEle = this.element.querySelector('label.select-label');
                if(this.selectInstance.getValue() === 'placeholder') this.element.classList.add('placeholder-selected');

                // On Change
                this.selectInstance.on('selectr.change', () => {
                    if(this.selectInstance.getValue() !== 'placeholder') {
                        this.element.classList.remove('placeholder-selected');
                    } else {
                        this.element.classList.add('placeholder-selected');
                    }

                    if(this.isMultiSelect) {
                        const allTags = this.element.querySelectorAll('li.selectr-tag');

                        if(allTags.length > 0) {
                            allTags[0].innerHTML = `${allTags.length} ${this.selectedLabel}`;
                        }
                    }
                });

                // On Open + Close
                this.selectInstance.on('selectr.open', () => labelEle.classList.add('open'));
                this.selectInstance.on('selectr.close', () => labelEle.classList.remove('open'));
            });
        }
    };

    /**
     * Initialize Component
     */
    init() {
        // Ensure we have a parent form element
        if(!this.elements.parentForm) return;

        // Init funcs
        this.useCustomSelects();
        this.addEventListeners();
    }
}

registerComponent(`.${componentName}`, FormOptions);
